// free-shipping-popup.js
// Opens the free shipping popup (sections/free-shipping-popup.liquid) instead of the cart drawer on every add to cart
// that leaves the cart below the free shipping threshold. While open, adds made from its suggestions update it in place.
(() => {
  const modal = document.getElementById('free-shipping-popup');
  if (!modal) return;

  const config = JSON.parse(modal.querySelector('[data-fsp-config]').textContent);
  const message = modal.querySelector('[data-fsp-message]');
  const progress = modal.querySelector('progress-bar');
  const suggestions = modal.querySelector('[data-fsp-suggestions]');
  const list = modal.querySelector('[data-fsp-list]');
  const cardTemplate = modal.querySelector('[data-fsp-card-template]');
  const products = JSON.parse(modal.querySelector('[data-fsp-products]').textContent);
  const MAX_SUGGESTIONS = 3;

  // Same total as the stock free-shipping-bar snippet: shippable lines minus cart-level discounts
  function eligibleTotal(cart) {
    const lines = cart.items.reduce((sum, i) => i.requires_shipping ? sum + i.final_line_price : sum, 0);
    const discounts = (cart.cart_level_discount_applications || []).reduce((sum, d) => sum + d.total_allocated_amount, 0);
    return lines - discounts;
  }

  // trimZeros matches Liquid's money_without_trailing_zeros (message); card prices keep cents like the theme's cards
  function formatMoney(cents, trimZeros = false) {
    const options = { style: 'currency', currency: Shopify.currency.active };
    if (trimZeros && cents % 100 === 0) options.minimumFractionDigits = options.maximumFractionDigits = 0;
    return new Intl.NumberFormat(Shopify.locale, options).format(cents / 100);
  }

  // Per product, the cheapest size that covers the remaining amount, else the priciest size below it.
  // Products whose pick covers it come first (cheapest first), then the closest ones below it.
  function pickSuggestions(cart, remaining) {
    const inCart = new Set(cart.items.map((i) => i.product_id));
    const picks = products.filter((p) => !inCart.has(p.id)).map((product) => {
      const covering = product.variants.filter((v) => v.price >= remaining).sort((a, b) => a.price - b.price);
      const below = product.variants.filter((v) => v.price < remaining).sort((a, b) => b.price - a.price);
      return { product, variant: covering[0] || below[0] };
    });

    const covers = picks.filter((p) => p.variant.price >= remaining).sort((a, b) => a.variant.price - b.variant.price);
    const below = picks.filter((p) => p.variant.price < remaining).sort((a, b) => b.variant.price - a.variant.price);
    return [...covers, ...below].slice(0, MAX_SUGGESTIONS);
  }

  function createCard({ product, variant }) {
    const card = cardTemplate.content.cloneNode(true);
    const onSale = variant.compareAtPrice > variant.price;

    card.querySelectorAll('[data-fsp-link]').forEach((link) => link.href = variant.url);
    card.querySelector('[data-fsp-title]').textContent = product.title;

    const image = card.querySelector('[data-fsp-image]');
    if (variant.image) {
      image.src = variant.image;
      image.alt = product.title;
    } else {
      image.closest('[data-fsp-link]').remove();
    }

    const variantTitle = card.querySelector('[data-fsp-variant-title]');
    variant.title ? variantTitle.textContent = variant.title : variantTitle.remove();

    const price = card.querySelector('[data-fsp-price]');
    price.textContent = formatMoney(variant.price);
    price.classList.toggle('text-on-sale', onSale);
    price.classList.toggle('text-subdued', !onSale);

    const compareAtPrice = card.querySelector('[data-fsp-compare-at-price]');
    onSale ? compareAtPrice.textContent = formatMoney(variant.compareAtPrice) : compareAtPrice.remove();

    card.querySelector('[data-fsp-variant-id]').value = variant.id;
    return card;
  }

  function showSuggestions(cart, remaining) {
    const picks = remaining > 0 ? pickSuggestions(cart, remaining) : [];
    list.replaceChildren(...picks.map(createCard));
    suggestions.hidden = picks.length === 0;
  }

  function render(cart) {
    const total = eligibleTotal(cart);
    const remaining = config.thresholdCents - total;

    message.innerHTML = remaining > 0 ? config.unreachedHtml.replace('[amount]', formatMoney(remaining, true)) : config.reachedHtml;
    progress.valueNow = Math.max(0, Math.min(total, config.thresholdCents));
    showSuggestions(cart, remaining);
  }

  // Runs in the capture phase so it sees the add before the cart drawer does; renaming baseEvent keeps the drawer
  // (the only listener that reads it) from opening, while it still re-renders its content from the same event.
  document.addEventListener('cart:change', (event) => {
    const detail = event.detail;
    if (!detail || detail.baseEvent !== 'variant:add' || !detail.cart) return;

    if (!modal.open && (detail.cart.item_count === 0 || eligibleTotal(detail.cart) >= config.thresholdCents)) return;

    detail.baseEvent = 'free-shipping-popup:add';
    detail.onSuccessDo = null;
    render(detail.cart);
    if (!modal.open) modal.show();
  }, { capture: true });

  modal.querySelector('[data-fsp-view-cart]').addEventListener('click', async (event) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    await modal.hide();
    drawer.show();
  });
})();
